class ContactsController {
    init() {

    }

    index() {
        // Table sorting and pagination now handled by Stimulus table controller
    }

    edit() {
        contactsOnEditOrNew();
    }

    new() {
        contactsOnEditOrNew();
    }
}

window.BC = window.BC || {};
window.BC.contacts = new ContactsController();

function contactsOnEditOrNew() {
    addOrRemoveFields();
}